"use client";

/**
 * WhatsApp order/delivery opt-in — a REAL, visible, pre-checked checkbox shown at
 * checkout ONLY when a phone number is present (WhatsApp needs a +91 mobile).
 *
 * This is a utility/transaction-completion choice the seeker can see and uncheck.
 * It authorizes order, fulfillment, and bounded checkout-recovery messages only;
 * it NEVER enrolls the contact in a recurring marketing audience. Its value
 * threads into `whatsapp_consent` on create-order for order-contract audit and
 * `recovery_phone_consent` on abandon for the seven-day recovery boundary.
 *
 * Single source of truth for the copy (rules 23/24 — no drifting copies): every
 * checkout surface (report CTA, chat paywall, agentic cart) renders THIS component,
 * so the label + framing can never diverge across surfaces.
 */

const WHATSAPP_OPT_IN_COPY: Record<"en" | "hi", string> = {
  en: "Get order & delivery updates on WhatsApp",
  hi: "Order aur delivery updates WhatsApp par paayein",
};

export function WhatsappOptInCheckbox({
  checked,
  onChange,
  language,
  disabled = false,
  className = "",
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
  language: "en" | "hi";
  disabled?: boolean;
  className?: string;
}) {
  const label = language === "hi" ? WHATSAPP_OPT_IN_COPY.hi : WHATSAPP_OPT_IN_COPY.en;
  return (
    <label
      className={`flex cursor-pointer items-center gap-2 text-caption text-text-secondary ${className}`.trim()}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        disabled={disabled}
        data-testid="whatsapp-optin-checkbox"
      />
      {label}
    </label>
  );
}
